export const GROW_VARIANT = 2;
export const BASIS_VARIANT = 56;
export const GROW_LOCATION = 2;
export const GROW_ACTIONS = 0;
export const BASIS_ACTIONS = 128;
